"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { Chip } from "../ui/Chip"; // your reusable chip

interface Tag {
    name: string;
    slug: string;
}

interface ChipsFormProps {
    chips: Tag[];
}

export default function ChipsForm({ chips }: ChipsFormProps) {
    const router = useRouter();

    const handleChipClick = (tagSlug: string) => {
        // Navigate to the topic page with the tag slug
        router.push(`/topic/${tagSlug}`);
    };

    return (
        <div className="flex flex-wrap gap-3 p-4">
            {chips.map((tag) => (
                <Chip
                    key={tag.slug}
                    label={tag.name}
                    onClick={() => handleChipClick(tag.slug)}
                />
            ))}
        </div>
    );
}
